    import { Meta, Title } from '@angular/platform-browser';
    import {Injectable } from '@angular/core';
import { ConfigService } from 'common';
 
    @Injectable({ providedIn: 'root' })
    export class HeaderMetaService {
        nonce: string | null;
      constructor(private meta: Meta,  private configService: ConfigService,) {}
 
      updateMetaTags(nonceValue:string) {
        if(this.configService._config.core.cspValue){
      this.meta.addTag({ httpEquiv: 'Content-Security-Policy', content: this.configService._config.core.cspValue.replaceAll("{nonceKey}",`'nonce-${nonceValue}'`) });
        }
      }
    }